export default {"src":"/_next/static/image/public/images/ic_afternoon.0308703b004af118a87375c6b75ecfb7.svg","height":18,"width":18};